<template>
  <div class="join">
    <div class="row top">
      <div class="col header-text">
        <h1>{{ $t('views.join.getFundingAs') }}<br/><span class="blue">{{ $t('views.join.loanOriginator') }}</span></h1>
        <h3>{{ $t('views.join.getAdditionalLiquidity') }}</h3>
        <div>
          <b-button class="join-btn" href="mailto:hello@getincome.com?subject=Get funding as Loan Originator">{{ $t('views.join.contactUs') }}</b-button>
        </div>
      </div>
      <div class="col top-block">
      </div>
    </div>
    <div class="how container">
      <div class="row">
        <div class="col-12">
          <div class="text-center main-question w-100">{{ $t('views.join.whatCanWe') }}</div>
          <div class="text-center answer w-100">{{ $t('views.join.incomeIsWorking') }}</div>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              <div class="join-title w-100">{{ $t('views.join.whyJoinIncome') }}</div>
              <div class="join-desc">
                <div>{{ $t('views.join.getFundingFor') }}</div>
                <div>{{ $t('views.join.workTogetherWith') }}</div>
                <div>{{ $t('views.join.gainTrackRecord') }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              <div class="join-title w-100">{{ $t('views.join.whatAreTheRequirements') }}</div>
              <div class="join-desc">
                <div>{{ $t('views.join.longEnoughTrack') }}</div>
                <div>{{ $t('views.join.professionallyRunBusiness') }}</div>
                <div>{{ $t('views.join.regulatoryComplianceIf') }}</div>
                <div>{{ $t('views.join.passingOurFinancial') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 how-does">
          <div class="w-100 how-header">{{ $t('views.join.howDoesItWork') }}</div>
          <div class="how-title">{{ $t('views.join.contactUs1') }}</div>
          <div class="how-desc">{{ $t('views.join.contactKimmoOur') }}<a target="_blank" class="blue" href="https://www.linkedin.com/in/kimmo-rytkonen/"><img class="lkdin" alt=""
                                                                                                                                                              src="../assets/linkedin.svg"/>{{
              $t('views.join.linkedinProfile')
            }}</a>{{ $t('views.join.orByEmailing') }}
          </div>
          <div class="how-title">{{ $t('views.join.duedilligence') }}</div>
          <div class="how-desc">{{ $t('views.join.wellStartDue') }}</div>
          <div class="how-title">{{ $t('views.join.receiveACommercialOffer') }}</div>
          <div class="how-desc">{{ $t('views.join.whenYouHave') }}</div>
          <div class="how-title">{{ $t('views.join.getListedAnd') }}</div>
          <div class="how-desc">{{ $t('views.join.onceAgreementHas') }}</div>
          <div class="how-title">{{ $t('views.join.ongoingCooperationAndMonitoring') }}</div>
          <div class="how-desc">{{ $t('views.join.weValuePartnerships') }}</div>
        </div>
      </div>
      <div class="row founded">
        <div class="col-12 col-md-6 col-lg-6 col-xl-6">
          <div class="left-section">
            <div class="our-promise">
              <h2><span class="blue">{{ $t('views.join.foundedIn') }}</span>{{ $t('views.join.weAreBringing') }}</h2>
              <div>
                <div class="description"><span class="blue">{{ $t('views.join.watch') }}</span>{{ $t('views.join.ourIntroductoryVideo') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-6">
          <div>
            <promo-video-schema></promo-video-schema>
            <iframe width="100%" height="315" src="https://www.youtube.com/embed/1ZBalOOlXNs" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PromoVideoSchema from '@/schema/PromoVideoSchema'
export default {
  name: 'LoanOriginatorsJoin',
  components: {PromoVideoSchema},
  data()
  {
    return {}
  }
}
</script>

<style scoped lang="scss">

.header-text {
  text-align: center;
  padding-left: 8%;
  margin: 82px auto 70px;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 15px;
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: center;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.top-block {
  background-image: url("../assets/join-lo-top-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.join-btn {
  background: #30A7FE;
  border-radius: 10px;
  color: white;
  border: none;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 34px;
  min-width: 250px;
  margin-top: 20px;
  text-transform: uppercase;
}

.main-question {
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 30px;
  text-align: center;
  color: #000000;
  margin-top: 80px;
  margin-bottom: 50px;
}

.answer {
  font-size: 16px;
  line-height: 24px;
  color: #6E777A;
  margin-bottom: 50px;
}

.join-title {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 30px;
  color: #000000;
  margin-top: 5px;
  margin-bottom: 20px;
  border-bottom: 1px solid #6E777A;
}

.join-desc {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #6E777A;

  div {
    margin-top: 10px;
  }
}

.how {
  margin-bottom: 20px;
}

.how-header {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 30px;
  color: #000000;
  margin-bottom: 5px;
  margin-top: 5px;
}

.how-title {
  font-weight: bold;
  margin-top: 20px;
  width: 100%;
}

.how-desc {
  color: #6E777A;
  text-align: justify;
}

.how-does {
  margin-top: 20px;
  border-top: 1px solid #6E777A;
  border-bottom: 1px solid #6E777A;
  padding-bottom: 5px;
}

.lkdin {
  width: 15px;
}

.founded {
  margin-top: 50px;
  margin-bottom: 50px;

  .left-section {
    .our-promise {
      h2 {
        font-weight: bold;
        font-size: 35px;
        line-height: 40px;
        margin-top: 15px;
        text-align: justify;
      }

      .description {
        font-size: 16px;
        line-height: 24px;
        color: #6E777A;
        margin-top: 50px;
        margin-bottom: 16px;
      }
    }
  }
}
</style>
